import { Component } from "react";

import React = require("react");
import moment from 'moment';
import Spinner from "../components/share/Spinners/Spinners";
import { PER_PAGE_LIMIT_GALLERY } from "../const/page-list";
import GalleryService from "../services/gallery";
import { DANH_MUC } from "../const/danh-muc";
import { GALLERY_VARIABLE } from "../const/gallery";
import { GALLERY } from "../const/seo-url";
import { formatUrlSeo } from "../util/seo-url";
import { loadImage } from "../util/image";
import { GALLERY_HINH } from "../components/gallery/util";
import HinhDetail from "../components/gallery/HinhDetail";
import Image from "../components/share/Image";
import { CONTENT } from "../const/content";
import { HeaderService } from "../services";
import ContentComponent from "../components/share/ContentComponent";
import Layout from "../components/share/Layout";
import { PageTransition } from "next-page-transitions";
import SpinnersImageText from "../components/share/Spinners/SpinnersImageText";
import Paginate from "../components/share/Paging";
import Modal from "../components/share/Modal";
// import ReactYoutube from "react-youtube";

interface State {}
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: '-50%',
    transform: "translate(-50%, -50%)",
    // width: '590px',
    background: "none",
    padding: 0,
    border: "none",
    "border-radius": "0px",
  },
  overlay: {
    zIndex: 99,
    backgroundColor: "rgba(2, 2, 2, 0.38)",
  },
};
export default class extends Component<any, any> {
  page: number = 1;
  per_page = 16;
  count: 0;

  rows = {
    dau: ``,
  };

  constructor(props) {
    super(props);
    this.count = 0;
    this.state = {
      danhSachGallery: [],
      page: 1,
      loading: false,
      album: [],
      open_hinh: false,
      url: "",
    };
  }

  static async getInitialProps({ req, query, asPath }) {
    const layoutProps = await Layout.getInitialProps();

    const danhMuc = asPath.substring(asPath.indexOf("=") + 1);
    const header = await HeaderService.getsHeader(
      [CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN],
      []
    );
    const CONTENT_ROYAL_HINHANH_BANNER_VN = header.contentValue.find(
      (x) => x.key == CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN
    );
    return {
      layoutProps,
      danhMuc: danhMuc,
      CONTENT_ROYAL_HINHANH_BANNER_VN: CONTENT_ROYAL_HINHANH_BANNER_VN.content,
    };
  }

  componentDidMount() {
    this.getGalleries(this.page);
  }

  prevPage = () => {
    window.scrollTo(0, 0);
    this.getGalleries(--this.page);
  };

  nextPage = () => {
    window.scrollTo(0, 0);
    this.getGalleries(++this.page);
  };
  getGalleries = (page) => {
    GalleryService.search(PER_PAGE_LIMIT_GALLERY, page, {
      danh_muc_id: this.props.danhMuc,
      loai: 'v',
    }).then((value) => {
      this.count = value.count;

      /**
       * xét hình đại diện
       */
      if (value && value.galleries && value.galleries.length > 0) {
        value.galleries.forEach((x) => {
          x["hinh_goc"] =x.hinh_dai_dien
          if (x.loai == GALLERY_VARIABLE.VIDEO) {
            x["url_chi_tiet"] =
              "/" +
              GALLERY.CHI_TIET_GALLERY_VIDEO +
              "/" +
              formatUrlSeo(x.url, x.gallery_id);
          }
        });
      }
      this.setState({
        danhSachGallery: value.galleries || [],
        loading: true,
      });
    });
  };

  onPageChange = (page) => {
    window.scrollTo(0, 0);
    this.getGalleries(page.selected + 1);
  };

  openModal(id) {
    this.setState({
      id: id,
      openModal: true,
    });
  }
  closeModal() {
    this.setState({
      openModal: false,
    });
  }
  modal() {
    const videoSrc = `https://www.youtube.com/embed/${this.state.id}`;
    return (
      <Modal
        isOpen={this.state.openModal}
        className="modal-video-yb"
        onRequestClose={() => this.closeModal()}
        contentLabel="Minimal Modal Example"
        style={customStyles}
        aria={{
          labelledby: "modalTitle",
        }}
      >
        {/* <ReactYoutube
          videoId={this.state.id}
          opts={{
            width: "100%",
          }}
        /> */}
        <span>
          <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="" width="100%" height="360" src={videoSrc} id="widget2" data-gtm-yt-inspected-9="true"></iframe>
        </span>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <Layout title={this.props.title} {...this.props.layoutProps}>
          {/* <PageTransition timeout={400} classNames="page-transition"> */}
          <div>
          {this.modal()}
            <ContentComponent
              content={this.props.CONTENT_ROYAL_HINHANH_BANNER_VN}
            />
            <div className="block">
              <div className="container">
                <div className="row">
                  <div className="col text-center block-title">
                    <span>VIDEO</span>
                  </div>
                </div>
                <div className="row">
                  {this.state.loading ? (
                    this.state.danhSachGallery.length > 0 ? (
                      this.state.danhSachGallery.map((video) => {
                        var id;
                        if (video.data.id.indexOf("&") == -1) {
                          id = video.data.id;
                        } else {
                          id = video.data.id.substring(
                            0,
                            video.data.id.indexOf("&")
                          );
                        }
                        return (
                          <div
                            className="col-md-4"
                            style={{ paddingLeft: "5px", paddingRight: "5px" }}
                            onClick={() => this.openModal(id)}
                            key={id}
                          >
                            <div
                              className="div-video-yb"
                              style={{
                                backgroundImage:
                                  "url(" + video.hinh_dai_dien + ")",
                              }}
                            >
                              <div className="btn-play-yb">
                                <div className="icon-play" />
                              </div>
                            </div>
                            <div
                              className="title-video text-center trimtext  back-yellow"
                              style={{ color: "rgb(46, 49, 145)" }}
                            >
                              <b>{video.tieu_de}</b>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-md-12">Không có gallery</div>
                    )
                  ) : (
                    <div className="col-md-12 col-lg-12 col-xl-12">
                      <SpinnersImageText type={"placeholde"} loading={true} />
                    </div>
                  )}
                </div>
                {+this.count > +PER_PAGE_LIMIT_GALLERY ? (
                  <div className="text-center">
                    <Paginate
                      onPageChange={this.onPageChange}
                      total={this.count}
                      perPage={PER_PAGE_LIMIT_GALLERY}
                      initialPage={this.state.page}
                    />
                  </div>
                ) : null}
              </div>
              {this.state.open_hinh ? (
                <HinhDetail
                  close={() => {
                    this.setState({
                      album: [],
                      open_hinh: false,
                    });
                  }}
                  images={this.state.album}
                  tieu_de={this.state.tieu_de}
                />
              ) : null}
            </div>
          </div>
          {/* </PageTransition> */}
          <style jsx global>
            {`
              .page-transition-enter {
                opacity: 0;
              }
              .page-transition-enter-active {
                opacity: 1;
                transition: opacity ${400}ms;
              }
              .page-transition-exit {
                opacity: 1;
              }
              .page-transition-exit-active {
                opacity: 0;
                transition: opacity ${400}ms;
              }
            `}
          </style>
        </Layout>
      </div>

      // </Layout>
    );
  }
}
